import { LineLayerSpecification } from 'mapbox-gl'

export class MapOutlineLayerFactory {
	static make(source: string = 'shape', id: string = 'Outline'): LineLayerSpecification {
		return {
			id,
			type: 'line',
			source,
			paint: {
				'line-color': ['coalesce', ['get', 'cor'], '#FEFEFE'],
				'line-width': ['coalesce', ['get', 'borda'], 2],
			},
		}
	}
}
